module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eaPh4"))).then(() => parcelRequire('5erN3'));